/* eslint-disable max-len */
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PipaylibService } from 'pipaylib';
import { AppdataService } from '../../services/appdata.service';
import { Order } from 'pipaylib/domain/order';
import { BluetoothSerial } from '@ionic-native/bluetooth-serial/ngx';
import { Distyconfig } from 'pipaylib/domain/distyconfig';
import html2PDF from 'jspdf-html2canvas';
import { toWords } from 'number-to-words';
import { LoadingController } from '@ionic/angular';
import { Distributor } from 'pipaylib/domain/distributor';
import { Distyretailer } from 'pipaylib/domain/distyretailer';
import * as pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts'; // Use default export if available
pdfMake.vfs = pdfFonts?.vfs || pdfFonts.pdfMake?.vfs;
import { Capacitor } from '@capacitor/core';
import * as FileSaver from 'file-saver';
import { FileOpener } from '@awesome-cordova-plugins/file-opener';
import { File } from '@awesome-cordova-plugins/file';

@Component({
  selector: 'app-recordsummarycard',
  templateUrl: './recordsummarycard.component.html',
  styleUrls: ['./recordsummarycard.component.scss'],
})
export class RecordsummarycardComponent implements OnInit {
  @Input() records: any[];
  @Input() distyconfig: Distyconfig;
  showBill: boolean;
  selectedOrder: any;
  curconfig: Distyconfig;
  distributor: Distributor;
  receivableAmountInWords: string;
  fetching: boolean;
  retailer: Distyretailer;
  base64ImageLogo: string | ArrayBuffer | null = null;
  outstandingAmount: number;

  constructor(public pipaylib: PipaylibService,
    private router: Router,
    private dataService: AppdataService,
    private bluetoothSerial: BluetoothSerial,
    public loadingCtrl: LoadingController) { }

  ngOnInit() {
    this.curconfig = this.pipaylib.loginService.loggedindistributor.distyconfig;
    this.distributor = this.pipaylib.loginService.loggedindistributor;
  }


  async sendPDF(record: any){
    this.selectedOrder = record;
    this.retailer = this.pipaylib.dataService.getRetailerForId(this.selectedOrder?.distyretailerid);
    if (this.selectedOrder && this.selectedOrder.cart) {
      this.showLoader('Sending bill...');
      this.receivableAmountInWords = toWords(this.selectedOrder.cart.payableamount);
      setTimeout(() => {
        this.generatePDF();
      }, 500);
    }
  }

  async getPendinginvoices(ret) {
    if (
      !this.pipaylib.invoiceService.pendinginvoicesfordisty ||
      this.pipaylib.invoiceService.pendinginvoicesfordisty.length === 0
    ) {
      await this.pipaylib.invoiceService.setDistypendingInvoices(
        this.pipaylib.loginService.loggedindistributor.id
      );
    } else {
      await this.pipaylib.invoiceService.updatePendingInvoices(
        this.pipaylib.loginService.loggedindistributor.id
      );
    }
    const pendingList = this.pipaylib.invoiceService.pendinginvoicesfordisty;
    const pendinginvoices = pendingList.filter(
      (item) =>
        item.distyretailerid === ret.id &&
        (item.invoicestatus === 'Delivered' ||
          item.invoicestatus === 'Payment failed' ||
          item.invoicestatus === 'Partially paid')
    );
    for (const inv of pendinginvoices) {
      if (!inv.failurecharges) {
        inv.failurecharges = 0;
      }
      if (!inv.paidamount) {
        inv.paidamount = 0;
      }
    }
    this.outstandingAmount = pendinginvoices.reduce(
      (acc, item) =>
        acc + (item.invoiceamount + item.failurecharges - item.paidamount),
      0
    );
  }


  async DownloadPDF(record: any){
    this.selectedOrder = record;
    this.retailer = this.pipaylib.dataService.getRetailerForId(this.selectedOrder?.distyretailerid);
    this.getPendinginvoices(this.retailer);

    if (this.selectedOrder && this.selectedOrder.cart) {
      this.showLoader('Sending bill...');
      this.receivableAmountInWords = toWords(this.selectedOrder.cart.payableamount);
      setTimeout(() => {
        this.downloadPDF();
        // this.hideLoader();
      }, 500);
    }

  }

  getRetailernameForId(order) {
    const distyretailers = this.pipaylib.solace.dataService.getMasterFromMap('distyretailer');
    for (const ret of distyretailers) {
      if (ret.id === order.distyretailerid) {
        order.retailername = ret.businessname;
        return ret.businessname;
      }
    }
    return null;
  }

  getCartItems(order: any) {
    let str = '';
    for (const item of order.cart.items) {
      if (order.cart.items.length === 1) {
        str += `${item.billedquantity}${item.uom} x ${item.productname}`;
      } else {
        if (item.productid === order.cart.items[order.cart.items.length - 1].productid) {
          str += `${item.billedquantity}${item.uom} x ${item.productname}`;
        } else {
          str += `${item.billedquantity}${item.uom} x ${item.productname}, `;
        }
      }
    }
    order.items = str;
    return str;
  }

  editOrder(order) {
    this.dataService.globalvars.set('orderforedit', order);
    this.router.navigate(['/requisition']);
  }

  // async printBill(ord: Order) {
  //   console.log(JSON.stringify(ord));
  //   // Determine which buffer to use based on printer size
  // let resultByte;
  // const printerSize = this.pipaylib.loginService.loggedinstaff.printersize;

  // if (printerSize === '4inch' || !printerSize) {
  //   console.log('4inch or unassigned');
  //   resultByte = await this.dataService.getBTPrintBuffer(ord);
  // } else {
  //   console.log('2inch');
  //   resultByte = await this.dataService.getBTPrintBuffer2inch(ord);
  // }

  //   const deviceid = localStorage.getItem('blprinter');
  //   console.log(deviceid);
  //   this.bluetoothSerial.connect(deviceid).subscribe(
  //    () => {
  //      console.log('Connected to printer');

  //      // Send data to printer
  //      this.bluetoothSerial.write(resultByte).then(() => {
  //        this.bluetoothSerial.clear();
  //        this.bluetoothSerial.disconnect();
  //        console.log('Print success');
  //      })
  //      .catch((err) => {
  //        console.error(err);
  //        this.bluetoothSerial.disconnect();
  //      });

  //    },
  //    (error) => {
  //      console.error('Error connecting to printer', error);
  //    }
  //  );
  // }

  async printBill(ord: Order) {
    // Determine which buffer to use based on printer size
    let resultByte;
    const printerSize = this.pipaylib.loginService.loggedinstaff.printersize;

    if (printerSize === '4inch' || !printerSize) {
      console.log('4inch or unassigned');
      resultByte = await this.dataService.getBTPrintBuffer(ord);
    } else {
      console.log('2inch');
      resultByte = await this.dataService.getBTPrintBuffer2inch(ord);
    }

    const deviceid = localStorage.getItem('blprinter');
    console.log(deviceid);
    this.bluetoothSerial.connect(deviceid).subscribe(
     () => {
       console.log('Connected to printer');

       // Send data to printer
       this.bluetoothSerial.write(resultByte).then(() => {
         this.bluetoothSerial.clear();
         this.bluetoothSerial.disconnect();
         console.log('Print success');
       })
       .catch((err) => {
         console.error(err);
         this.bluetoothSerial.disconnect();
       });

     },
     (error) => {
       console.error('Error connecting to printer', error);
     }
   );
  }

  // ✅ Helper function to add delay
  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  downloadPDF() {
    // PDF generation
    const pdfContent = this.getPDFContent();
    const distributorId = this.pipaylib.loginService.loggedindistributor.id;
    const timestamp = new Date().getTime();
    const pdfname = `Order_${distributorId}_${timestamp}.pdf`;
    const pdf = pdfMake.createPdf(pdfContent);

    // Debugging: Check if PDF is generated correctly
    pdf.getBlob((blob) => {
      console.log('PDF Blob:', blob);
    });

     // Check platform and save PDF
     if (Capacitor.isNativePlatform()) {
       pdf.getBuffer((buffer: any) => {
         const blob = new Blob([buffer], { type: 'application/pdf' });
         File.writeFile(File.dataDirectory, pdfname, blob, { replace: true })
           .then((fileEntry) => {
             FileOpener.open(File.dataDirectory + pdfname, 'application/pdf')
               .catch((err) => console.error('Error opening file:', err));
           })
           .catch((err) => console.error('Error writing file:', err));
       });
     } else {
       pdf.getBlob((blob) => {
         FileSaver.saveAs(blob, pdfname);
       });
    }
    this.hideLoader();
 }

  generatePDF() {
    const pdfContent = this.getPDFContent();
    const pdfDocGenerator = pdfMake.createPdf(pdfContent);
    const distributorId = this.pipaylib.loginService.loggedindistributor.id;
    const timestamp = new Date().getTime();
    const pdfname = `Order_${distributorId}_${timestamp}.pdf`;

    pdfDocGenerator.getBlob(async (blob: Blob) => {
      try {
        // const billpdffile = new File([blob], pdfname, { type: 'application/pdf' });
        const billpdffile = new Blob([blob], { type: 'application/pdf' }) as File;
        const uploadResult = await this.uploadFile(billpdffile, pdfname);
        if (uploadResult.status === 'success') {
          const pdfurl = `https://s3.ap-south-1.amazonaws.com/foodkartiposimages/${pdfname}`;
          const ord = this.selectedOrder;
          await this.sendBillOnWhatsApp(ord, pdfurl, pdfname);
        }
      } catch (error) {
        console.error('File upload failed:', error);
      } finally {
        this.hideLoader();
      }
    });
  }

  async uploadFile(file: File, filename: string): Promise<any> {
    try {
      const result = await this.pipaylib.solace.utilService.uploadFiletoS3(file, filename, 'foodkartiposimages');
      return result;
    } catch (error) {
      console.error('Error uploading file:', error);
      throw error;
    }
  }

  async sendBillOnWhatsApp(order, pdfurl, pdfname) {
    const retailer = this.retailer;
    try {
      if (this.pipaylib.loginService.loggedinstaff.distributorid === '1720764526876') {
        const url = 'https://webhooks.whatapi.in/webhook/6777ea99ea04d946eaf8404c?number=91'
          + retailer.mobileno
          + '&var1=' + retailer.businessname
          + '&var2=' + order.billseq
          + '&var3=' + order.cart.payableamount.toFixed(2)
          + '&medialink=' + pdfurl
          + '&pdfname=invoice';
        const resp = await this.pipaylib.solace.dbLib.httpdataService.httpRequest(url, 'GET', null, null);
      } else {
        await this.pipaylib.invoiceService.sendBillOnWhatsApp(
          order.billseq,
          retailer.mobileno,
          pdfurl,
          pdfname,
          retailer.businessname,
          order.cart.payableamount.toFixed(2)
        );
      }
    } catch (error) {
      console.error('Error sending bill on WhatsApp:', error);
      throw error;
    }
  }


  convertToBase64(fileUrl: string) {
    fetch(fileUrl)
      .then(res => res.blob())
      .then(blob => {
        const fileReader = new FileReader();
        fileReader.onload = () => {
          this.base64ImageLogo = fileReader.result;
          // You can now use this.base64Image in your component
        };
        fileReader.readAsDataURL(blob);
      })
      .catch(error => {
        console.error('Error converting file to base64:', error);
      });
  }


  getPDFContent()
  {
    let itemsTableBody;
    let gstBifurcationBody;
    let widthForTableBody;
    let widthForGstTableBody;

    if (this.curconfig.nogstinbill) {
      itemsTableBody = [['S.No', 'Product Name', 'Qty', 'UOM', 'Rate', 'Discount', 'NetAmt']];
      widthForTableBody = ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto'];
      gstBifurcationBody = [];
      widthForGstTableBody = [];
    } else if (this.curconfig.cessinbill) {
      itemsTableBody = [
        [
          'S.No',
          'Product Name',
          'Qty',
          'UOM',
          'Rate',
          'Discount',
          'Taxable Amount',
          'GST Rate',
          'CESS Rate',
          'Taxes',
          'NetAmt',
        ],
      ];
      gstBifurcationBody = [['GST%', 'CGST', 'SGST', 'IGST', 'CESS']];
      widthForTableBody = ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
      widthForGstTableBody = ['*', 'auto', 'auto', 'auto', 'auto'];
    } else {
      itemsTableBody = [
        ['S.No', 'Product Name', 'Qty', 'UOM', 'Rate', 'Discount', 'Taxable Amount', 'GST Rate', 'Taxes', 'NetAmt'],
      ];
      gstBifurcationBody = [['GST%', 'CGST', 'SGST', 'IGST']];
      widthForTableBody = ['auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'];
      widthForGstTableBody = ['*', 'auto', 'auto', 'auto'];
    }

    // Check if selectedOrder and cart items are defined
    if (this.selectedOrder && this.selectedOrder.cart && this.selectedOrder.cart.items) {
      this.selectedOrder.cart.items.forEach((item, index) => {
        const rowData = [
          index + 1,
          `${item.productname}${item.hsnno ? `\nHSN: ${item.hsnno}` : ''}${item.narration ? `\n${item.narration}` : ''}`,
          item.actquantity,
          item.uom,
          item.rate ? item.rate.toFixed(2) : '0.00',
          item.disc ? item.disc.toFixed(2) : '0.00',
        ];

        if (!this.curconfig.nogstinbill) {

          rowData.push(
            item.billedamount ? item.billedamount.toFixed(2) : '0.00',
            item.gstrate ? `${item.gstrate}%` : '0%',
            this.curconfig.cessinbill && (item.cessrate ? `${item.cessrate}%` : '0%'),
            item.cgst + item.sgst + item.igst + item.cess
              ? (item.cgst + item.sgst + item.igst + item.cess).toFixed(2)
              : '0.00',
          );
        }

        rowData.push(
          ((item.cgst ?? 0) + (item.sgst ?? 0) + (item.igst ?? 0) + (item.cess ?? 0) + (item.billedamount ?? 0)).toFixed(
            2,
          ),
        );

        itemsTableBody.push(rowData.filter(Boolean));
      });

      // Footer Of tabel
      const footerRow = [
        'Total',
        ' ',
        this.selectedOrder.billedqty,
        ' ',
        ' ',
        (this.selectedOrder?.cart.totaldisc).toFixed(2),
      ];

      if (!this.curconfig.nogstinbill) {
        footerRow.push(
          this.curconfig.cessinbill ? ' ' : null,
          (this.selectedOrder?.cart.gst).toFixed(2),
          ' ',
          (this.selectedOrder?.cart.billedamount).toFixed(2),
        );
      }

      footerRow.push((this.selectedOrder?.cart.netamount).toFixed(2));

      itemsTableBody.push(footerRow.filter(Boolean));
    }

    // Check if GST bifurcation list is defined
    if (
      !this.curconfig.nogstinbill &&
      this.selectedOrder &&
      this.selectedOrder.cart &&
      this.selectedOrder.cart.gstbifurcationlist
    ) {
      this.selectedOrder.cart.gstbifurcationlist.forEach((gstb) => {
        gstBifurcationBody.push(
          [
            gstb.gstrate ? `${gstb.gstrate}%` : '0.00%',
            gstb.cgstamount ? gstb.cgstamount.toFixed(2) : '0.00',
            gstb.sgstamount ? gstb.sgstamount.toFixed(2) : '0.00',
            gstb.igstamount ? gstb.igstamount.toFixed(2) : '0.00',
            this.curconfig.cessinbill &&
              (gstb.gstrate === 28
                ? this.selectedOrder.cart.cess
                  ? this.selectedOrder.cart.cess.toFixed(2)
                  : '0.00'
                : '0.00'),
          ].filter(Boolean),
        ); // Filter out false values to avoid undefined cells
      });
    }

    return {
          content: [
            {
              columns: [
                {
                    width: '100%',
                    stack: [
                        {
                          text: `Bill No: ${this.selectedOrder.billseq ? this.selectedOrder.billseq : this.selectedOrder.id}`,
                          style: 'Rsubheader',
                          alignment: 'right',
                          bold: true
                        },
                        {
                          text: `Date: ${this.selectedOrder.orderdate}`,
                          style: 'Rsubheader',
                          alignment: 'right'
                        },
                        { text: `Salesman: ${this.selectedOrder.salesstaffname}`,
                          style: 'Rsubheader',
                          alignment: 'right',
                          margin: [0, 0, 0, 10]
                        }
                    ]
                }
              ]
            },
            {
                columns: [
                    {
                        width: '60%',
                        stack: [
                            { text: this.distributor.businessname, style: 'Lsubheader', bold: true },
                            `${this.distributor.addressline1} ${this.distributor.addressline2}`,
                            `Contact: ${this.distributor.mobileno}`,
                            `GSTIN: ${this.distributor.gstinno}`,
                            `GST State: ${this.distributor.statename}`,
                            `PAN: ${this.distributor.panno}`
                        ]
                    },
                    {
                        width: '40%',
                        stack: [
                            { text: this.selectedOrder.distyretailername, style: 'Rsubheader', bold: true, alignment: 'right' },
                            { text: `${this.retailer.addressline1 ? this.retailer.addressline1 : ''} ${this.retailer.addressline2 ?
                              this.retailer.addressline2 : ''}`, alignment: 'right' },
                            { text: `Contact: ${this.retailer.mobileno}`, alignment: 'right' },
                            { text: `GSTIN: ${this.retailer.gstinno ? this.retailer.gstinno : ''}`, alignment: 'right' },
                            { text: `GST State: ${this.retailer.gststate ? this.retailer.gststate : ''}`, alignment: 'right' },
                            { text: `PAN: ${this.retailer.panno ? this.retailer.panno : ''}`, alignment: 'right' }
                        ]
                    }
                ]
            },
            {
                style: 'tableTitle',
                margin: [0, 10, 0, 10],
                table: {
                    headerRows: 1,
                    widths: widthForTableBody,
                    body: itemsTableBody
                }
            },
            {
                columns: [
                    {
                        width: '70%',
                        stack: this.curconfig.nogstinbill ? [] : [
                            { text: 'GST Bifurcation Details:', style: 'Lsubheader' },
                            {
                                table: {
                                    headerRows: 1,
                                    widths: widthForGstTableBody,
                                    body: gstBifurcationBody,
                                    margin: [0, 0, 20, 0]
                                }
                            }
                        ]
                    },
                    {
                        width: '30%',
                        stack: [
                            { text: 'Summary:', style: 'Rsubheader', alignment: 'right' },
                            {
                              text: `Item Amount: ${this.selectedOrder.cart.itemamount.toFixed(2)}`,
                              style: 'Rsubheader',
                              alignment: 'right'
                            },
                            {
                              text: `Total Discount: ${this.selectedOrder.cart.totaldisc.toFixed(2)}`,
                              style: 'Rsubheader',
                              alignment: 'right'
                            },
                            ...(!this.curconfig.nogstinbill ? [
                                {
                                    text: `Total CGST: ${this.selectedOrder.cart.cgst ?
                                    this.selectedOrder.cart.cgst.toFixed(2) : '0.00'}`,
                                    style: 'Rsubheader',
                                    alignment: 'right'
                                },
                                {
                                    text: `Total SGST: ${this.selectedOrder.cart.sgst ? this.selectedOrder.cart.sgst.toFixed(2) : '0.00'}`,
                                    style: 'Rsubheader',
                                    alignment: 'right'
                                }
                            ] : []),
                            {
                              text: `Round Off: ${this.selectedOrder.cart.roundingamt.toFixed(2)}`,
                              style: 'Rsubheader',
                              alignment: 'right'
                            },
                            {
                              text: `Billed Amt: ${this.selectedOrder.cart.payableamount.toFixed(2)}`,
                              style: 'Rsubheader',
                              bold: true,
                              alignment: 'right'
                            }
                        ]
                    }
                ]
            },
            {
                columns: [
                    {
                        width: '100%',
                        stack: [
                            { text: `In Words: ${this.receivableAmountInWords.toUpperCase()}`, alignment: 'left', margin: [0, 10] },
                            {
                                text: 'Declaration: We here by certify that food/foods mentioned in this invoice is/are warranted to be the nature and quality which they purport to be.',
                                alignment: 'left',
                                margin: [0, 10],
                                fontSize: 12
                            }
                        ]
                    }
                ]
            },
            {
              columns: [
                {
                    width: '50%',
                    stack: [
                      {
                        text: `Previous Outstanding: ₹ ${((this.outstandingAmount - this.selectedOrder.cart.payableamount).toFixed(2))}`,
                        style: 'header',
                        alignment: 'left',
                        margin: [0, 5, 0, 0], // Reduced top margin
                        bold: true
                      },
                      {
                          text: `Total Outstanding: ₹ ${this.outstandingAmount.toFixed(2)}`,
                          style: 'header',
                          alignment: 'left',
                          margin: [0, 0, 0, 0], // Removed bottom margin to align with signature
                          bold: true
                      }
                    ]
                },
                {
                    width: '50%',
                    stack: [
                        {
                            text: 'Customer Signature',
                            style: 'header',
                            alignment: 'right',
                            margin: [0, 0, 0, 0], // Ensures it is aligned with the previous column
                            bold: true
                        }
                    ],
                    alignment: 'center', // Ensures vertical alignment
                    margin: [0, -5, 0, 0] // Adjusting position slightly upward
                }
            ]
          },
            {
                columns: [
                    {
                        width: '30%',
                        stack: [
                            { text: '(E.O.E)', style: 'Lsubheader', margin: [0, 10], bold: true }
                        ]
                    },
                    {
                        width: '45%',
                        stack: [
                            { text: `CHQ RETURN CHARGE ${this.curconfig.failurecharges}`, style: 'Lsubheader', margin: [0, 10] }
                        ]
                    },
                    {
                        width: '25%',
                        stack: [
                            { text: `For: ${this.distributor.businessname}`, style: 'Lsubheader', margin: [0, 10], bold: true, alignment: 'right' }
                        ]
                    }
                ]
            }
          ]
      };
  }


hideLoader() {
  if (this.fetching) {this.fetching = false;}
  return this.loadingCtrl
    .dismiss()
    .catch((e) => console.log(e));
}

showLoader(msg) {
  if (!this.fetching) {this.fetching = true;}
  return this.loadingCtrl
    .create({
      message: msg,
      spinner: 'bubbles',
    })
    .then((res) => {
      res.present().then(() => {
        if (!this.fetching) {
          res.dismiss().then(() => {
          });
        }
      });
    })
    .catch((e) => {
      this.fetching = false;
    });
}

}
